// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"102a3766","239":"83bacca0","453":"de908bf8","970":"155c5b3a"}[chunkId] + ".chunk.js";
};